import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'success-popup',
    components: {
    },
})


export default class SuccessPopupComponent extends Vue {

    @Prop() public contentTitle!: string;
    @Prop() public contentBody!: string;
    @Prop() public buttonTitle!: string;
    @Prop() public isConfirm!: boolean;
    public localContentTitle: string = '';
    public localContentBody: string = '';
    public localButtonTitle: string = '';

    public created() {
        this.localContentTitle = this.contentTitle;
        this.localContentBody = this.contentBody;
        this.localButtonTitle = this.buttonTitle;
    }

    public onConfirm() {
        if (this.isConfirm) {
            this.$emit('onConfirm', true);
        } else {
            this.onCancel();
        }
    }

    public onCancel() {
        this.$emit('onCancel');
    }

    @Watch('contentTitle')
    private onContentTitleChange(newTitle: string) {
        this.localContentTitle = newTitle;
    }

    @Watch('contentBody')
    private onContentBodyChange(newBody: string) {
        this.localContentBody = newBody;
    }

    @Watch('buttonTitle')
    private onButtonTitleChange(newButtonTitle: string) {
        this.localButtonTitle = newButtonTitle;
    }
}
